import { Customer } from "./Customer";
import { Product } from "./Product";
import { Transaction } from "./Transaction";

export interface DeliveryInfo {
  provider?: string;
  trackingNumber?: string;
  deliveryStatus?: "pending" | "pickup_scheduled" | "out_for_delivery" | "delivered" | "cancelled" | "failed";
  waybillUrl?: string;
  dispatchedAt?: Date;
  deliveredAt?: Date;
  notes?: string;
}

export interface Order {
  _id: string;
  orderId: number;
  customer?: Customer;
  product: Product;
  qty: number;
  transaction: Transaction;
  status: OrderStatus;
  deliveryInfo?: DeliveryInfo;
  selected?: boolean;
  createdAt: Date;
}
export enum OrderStatus {
  CONFIRMED = "confirmed",
  PENDING = "pending",
  CANCELLED = "canceled",
}

export interface UpdateOrderModel {
  status?: OrderStatus;
}
